<template>
  <div class="photographManage-container">
    <div id="map-box"></div>
    <el-header class="watch-header">
      <el-row class="header-title">地拍管理平台</el-row>
    </el-header>
    <div class="close-switch">
      <li class="switchItem" v-for="item in switchList" :key="item.id">
        <template>
          <div class="imgWrapper">
            <img :src="item.img" />
          </div>
          <el-switch
            class="switchBtn"
            :value="item.switchStatus"
            @click.native="item.switchStatus = !item.switchStatus"
            @change="switchChange(item)"
            active-color="#F4324D"
            inactive-color="#24D85B"
          >
          </el-switch>
        </template>
      </li>
    </div>
    <!-- 高德地图点击车辆标注显示的盒子 -->
    <el-row class="infoWindow" ref="vehicleInfowindow" v-show="vehicleId">
      <i class="delta"></i>
      <el-row
        class="orderTime"
        v-if="
          vehicleInfoWindowData.orderState &&
            vehicleInfoWindowData.orderState != 1
        "
      >
        <el-col :span="8">工单历时</el-col>
        <el-col :span="16">{{ vehicleInfoWindowData.takeTime }}</el-col>
      </el-row>
      <el-row class="infoWindow-detail">
        <el-row class="vehicleStatus">
          <span class="powering" v-if="vehicleInfoWindowData.powerState == 1"
            >发电中</span
          >
          <span
            class="fueling"
            v-if="vehicleInfoWindowData.oilPumpingState == 1"
            >抽油中</span
          >
          <span class="no-receive" v-if="vehicleInfoWindowData.orderState == 1"
            >未接单</span
          >
          <span class="routing" v-if="vehicleInfoWindowData.orderState == 2"
            >在途中</span
          >
          <span class="routing" v-if="vehicleInfoWindowData.orderState == 3"
            >已接单</span
          >
        </el-row>
        <el-row class="carNumber">{{ vehicleInfoWindowData.plateNum }}</el-row>
        <el-row>{{ vehicleInfoWindowData.name }}</el-row>
        <el-row>{{ vehicleInfoWindowData.phone }}</el-row>
        <el-row>
          <span>剩余油量：</span>
          <span>{{
            vehicleInfoWindowData.version == 2
              ? "-"
              : vehicleInfoWindowData.adFuel + "L"
          }}</span>
        </el-row>
        <el-row>
          <span>当前车速：</span>
          <span>{{ vehicleInfoWindowData.absVehicleSpeed }}KM/H</span>
        </el-row>
        <el-row v-if="vehicleInfoWindowData.powerState == 1">
          <el-row>
            <span>发电功率：</span>
            <span>{{ vehicleInfoWindowData.forwardPower }}W</span>
          </el-row>
          <el-row>
            <span>发电时长：</span>
            <span>{{ vehicleInfoWindowData.duration }}</span>
          </el-row>
          <el-row>
            <span>发电量：</span>
            <span>{{ vehicleInfoWindowData.capacity }}KW·H</span>
          </el-row>
        </el-row>
        <el-row v-if="bankRoute">
          <!-- <el-row v-if="(vehicleInfoWindowData.orderState == 2&&vehicleInfoWindowData.powerState != 1) || bankRoute"> -->
          <el-row>
            <span>预计行程：</span>
            <span>{{ drivingRoutel }}</span>
          </el-row>
          <el-row>
            <span>预计用时：</span>
            <span>{{ drivingTime }}</span>
          </el-row>
        </el-row>
      </el-row>
      <span
        class="checkDetail"
        @click="getVehicleDetail(vehicleInfoWindowData.vin)"
        v-if="hasPerm('maintain:monitor:vehicle:details:v3')"
      >
        查看详情
      </span>
    </el-row>
  </div>
</template>

<script>
import AMap from "AMap";
import pointsData from "./data.json";
export default {
  name: "PhotographManage",
  data() {
    return {
      map: null,
      vehicleLocal: [],
      vehicleMarker: [],
      powerStateMarker: "",
      plateNumMarker: null,
      vehicleMarkerList: [],
      vehicleInfoWindow: null,
      vehicleInfoWindowData: {},
      vehicleId: false,
      routeLine: null,
      bankRoute: false,
      drawOK: true,
      switchList: [
        // 控制显示车辆标记点
        {
          id: 1,
          type: 1,
          img: require("@/assets/images/monitor/car-online.png"),
          switchStatus: false,
          limit: "maintain:monitor:station:display",
        },
        // 控制显示点位标记点
        {
          id: 2,
          type: 2,
          img: require("@/assets/images/geological/massGreen.png"),
          switchStatus: false,
          limit: "maintain:monitor:station:display",
        },
      ],
      pointsMassMarks: null,
      lnglats: [],
      points: [],
      polygons: [],
      district: null,
      marker: null,
      cluster: null, // 点聚合
      area: 0,
      pointCircle: null,
      // locationError: true,
      mapClick: false,
      fillColor: "rgba(54, 123, 207,.4)",
      scale: null,
    };
  },

  beforeRouteLeave(to, from, next) {
    if (to.path == "/VehicleInfo") {
      let path = from.path; //path为定义的变量，不是vue的data定义的变量，当前生命周期data还未初始化
      sessionStorage.setItem("pathUrl", path);
    }
    next();
  },

  // watch: {
  //   changeLocationError: {

  //     handler() {
  //       // if (val) {
  //       //   console.log("1111111111");
  //       //   let location = [];
  //       //   this.vehicleMarkerList.forEach((item) => {
  //       //     location.push(item.lnglat);
  //       //   });
  //       //   //1.把想自适应的部分的点装在一个透明的覆盖物图层里
  //       //   let polygon = new AMap.Polygon({
  //       //     path: location, //使用所有车辆点的坐标创建一个隐藏的多边形
  //       //     map: this.map,
  //       //     strokeOpacity: 0, //透明
  //       //     fillOpacity: 0, //透明
  //       //     bubble: true, //事件穿透到地图
  //       //   });
  //       //   console.log(polygon);
  //       //   // let overlaysList = this.map.getAllOverlays("polygon"); //获取多边形图层
  //       //   //2.使用setFitView方法
  //       //   this.map.setFitView(overlaysList); //自适应显示
  //       // }
  //     },
  //     immediate: true,
  //   },
  // },
  // computed: {
  //   changeLocationError: function() {
  //     return this.locationError;
  //   },
  // },

  mounted() {
    this.initMap();
    this.getPointData();
    // this.drawBounds("苍南");
    this.getVehicleLocation();
  },

  methods: {
    // 获取点数据
    getPointData() {
      let points = [];
      let location = []; // 所有原始数据的点坐标
      let coordinate = [];
      pointsData.forEach((item, i) => {
        //   let lng = item.logGd.substring(0, item.logGd.lastIndexOf(".") + 7);
        //   let lat = item.latGd.substring(0, item.latGd.lastIndexOf(".") + 7);
        let lng = item.logGd.toFixed(6);
        let lat = item.latGd.toFixed(6);
        coordinate = [lng, lat];
        points.push({
          lnglat: coordinate,
          name: item.township,
          id: i + 1,
          monitorArea: item.area,
        });
        location.push(coordinate);
      });
      // let locationArr = this.chunk(location, 40);
      this.addPointsMarkers(points);
      // console.log(points);
    },

    // 使用高德坐标转换 api
    lastLocation(array) {
      let locations = [];
      array.forEach(async (item) => {
        AMap.convertFrom(item, "gps", function(status, result) {
          if (result.info === "ok") {
            let lnglats = result.locations[0]; // Array.<LngLat>
            locations.push(lnglats);
          }
        });
      });
      return locations;
    },

    // 处理数组数据，没40个数组为一组数据
    chunk(arr, size) {
      var result = [];
      for (var i = 0, len = arr.length; i < len; i += size) {
        result.push(arr.slice(i, i + size));
      }
      return result;
    },

    // 计算占地面积,画圆
    drawCircle(area, lnglat) {
      // console.log(area, lnglat);
      if (this.pointCircle) {
        this.pointCircle.hide();
      }
      // 半径
      let R = Math.sqrt(area * (2000 / 3) * Math.PI);
      this.pointCircle = new AMap.CircleMarker({
        center: lnglat, // 圆心位置
        radius: R, // 圆半径
        fillColor: this.fillColor, // 圆形填充颜色
        strokeColor: "transparent", // 描边颜色
        // strokeWeight: 2, // 描边宽度
        zIndex: 1,
      });
      this.map.add(this.pointCircle);
    },
    // 行政区区域划分
    drawBounds(newValue) {
      //加载行政区划插件
      if (!this.district) {
        //实例化DistrictSearch
        var opts = {
          subdistrict: 0, //获取边界不需要返回下级行政区
          extensions: "all", //返回行政区边界坐标组等具体信息
          level: "district", //查询行政级别为 县
        };

        this.map.plugin(["AMap.DistrictSearch"], () => {
          this.district = new AMap.DistrictSearch(opts);
        });
        // this.district = new AMap.DistrictSearch(opts)
      }
      //行政区查询
      this.district.search(newValue, (status, result) => {
        if (this.polygons != null) {
          this.map.remove(this.polygons); //清除上次结果
          this.polygons = [];
        }
        var bounds = result.districtList[0].boundaries;
        if (bounds) {
          for (var i = 0, l = bounds.length; i < l; i++) {
            //生成行政区划polygon
            var polygon = new AMap.Polygon({
              strokeWeight: 2,
              path: bounds[i],
              fillOpacity: 0.2,
              fillColor: "transparent",
              strokeColor: "#ffff33",
            });
            this.polygons.push(polygon);
          }
        }
        this.map.add(this.polygons);
        this.map.setFitView(this.polygons); //视口自适应
      });
    },

    // 按钮切换清除地图海量点标记
    switchChange(item) {
      let sessionName = "type" + item.type;
      sessionStorage.setItem(sessionName, !item.switchStatus);
      if (item.switchStatus) {
        if (item.type == 1) {
          // 车辆显示
          this.showVehicleData();
        }
        if (item.type == 2) {
          console.log("标记点显示");
          // 标记点显示
          this.showPointData();
        }
      } else {
        if (item.type == 1) {
          // 关闭车辆显示
          this.hideVehicle();
        }
        if (item.type == 2) {
          // 关闭标记点显示
          this.hidePoint();
        }
      }
    },

    showVehicleData() {
      this.map.add(this.vehicleMarker);
      if (!this.vehicleInfoWindow) {
        this.vehicleInfoWindow.show();
      }
    },
    // 关闭车辆显示
    hideVehicle() {
      this.map.remove(this.vehicleMarker);
      if (this.routeLine) {
        this.map.remove(this.routeLine);
        this.routeLine = null;
      }
      this.vehicleInfoWindow.hide();
    },

    showPointData() {
      this.pointsMassMarks.show();
      if (!this.marker) {
        this.map.add(this.marker);
      }
    },
    // 关闭标记点显示
    hidePoint() {
      console.log("关闭标记点显示", this.pointsMassMarks);
      this.pointsMassMarks.hide();
      this.map.remove(this.marker);
    },

    //获取车辆定位信息
    async getVehicleLocation() {
      let { data: res } = await this.$axios.get(
        "/api/v3/maintain/monitor/vehicle"
      );
      if (res.code == 1) {
        this.vehicleLocal = res.data;
        this.addVehicleMarker();
      } else {
        this.$message.warning(res.msg);
      }
    },

    //添加车辆标记
    addVehicleMarker() {
      let data = this.vehicleLocal;
      if (this.vehicleMarker.length > 0) {
        this.map.remove(this.vehicleMarker);
        this.vehicleMarkerList = [];
        this.vehicleMarker = [];
      }
      for (var i = 0; i < data.length; i++) {
        this.varMarker = "";
        this.powerStateMarker = "";
        this.plateNumMarker = "";
        if (data[i].powerState == 1) {
          var powerContent =
            "<img style='width:14px;height:18px'  src='" +
            require("@/assets/images/monitor/icon-powering.png") +
            "'/>";
          this.powerStateMarker = new AMap.Marker({
            zIndex: 200,
            content: powerContent,
            position: data[i].lnglat,
            offset: new AMap.Pixel(-30, -12),
            map: this.map,
          });
        }
        if (data[i].vehicleState == 1) {
          let icon =
            data[i].version == 2
              ? require("@/assets/images/monitor/car-offline-2.png")
              : require("@/assets/images/monitor/car-offline.png");
          this.varMarker = new AMap.Marker({
            position: data[i].lnglat,
            icon: icon,
            size: new AMap.Size(40, 24),
            map: this.map,
            autoRotation: true, // 车辆行驶过程中，方向可变属性
            offset: new AMap.Pixel(-20, -12),
            clickable: true,
            zIndex: 100,
            angel: -90,
          });
          var plateNumContent =
            "<div style='position:relative'><img style='width:80px;height:27px'  src='" +
            require("@/assets/images/monitor/plateNum.png") +
            "'/><span style='position:absolute;color:#fff;font-size:12px;left:12px;top:3px'>" +
            data[i].plateNum +
            "</span></div>";
          this.plateNumMarker = new AMap.Marker({
            zIndex: 100,
            content: plateNumContent,
            position: data[i].lnglat,
            offset: new AMap.Pixel(-40, -42),
            map: this.map,
          });
        } else {
          let icon =
            data[i].version == 2
              ? require("@/assets/images/monitor/car-online-2.png")
              : require("@/assets/images/monitor/car-online.png");
          this.varMarker = new AMap.Marker({
            position: data[i].lnglat,
            icon: icon,
            size: new AMap.Size(40, 24),
            map: this.map,
            autoRotation: true, // 车辆行驶过程中，方向可变属性
            offset: new AMap.Pixel(-20, -12),
            zIndex: 120,
            clickable: true,
            angel: -90,
          });
          var plateContent =
            "<div style='position:relative'><img style='width:80px;height:27px'  src='" +
            require("@/assets/images/monitor/plateNum.png") +
            "'/><span style='position:absolute;color:#fff;font-size:12px;left:12px;top:3px'>" +
            data[i].plateNum +
            "</span></div>";
          this.plateNumMarker = new AMap.Marker({
            zIndex: 120,
            content: plateContent,
            position: data[i].lnglat,
            offset: new AMap.Pixel(-40, -42),
            map: this.map,
          });
          // 判断车辆方向
          this.varMarker.moveAlong(data[i].directionLnglat, 50); //车辆行驶方向
        }
        this.varMarker.content = data[i]; // 车辆信息窗体内容
        this.vehicleMarker.push(this.varMarker);
        // this.vehicleMarker.push(this.oilStateMarker)
        this.vehicleMarker.push(this.powerStateMarker);
        this.vehicleMarker.push(this.plateNumMarker);
        this.vehicleMarkerList.push({
          vin: data[i].vin,
          lnglat: data[i].lnglat,
          vehicle: this.varMarker,
          plateNum: this.plateNumMarker,
          // oil: this.oilStateMarker,
          power: this.powerStateMarker,
        });
        AMap.event.addListener(this.varMarker, "click", (e) => {
          this.vin = e.target.content.vin;
          this.deptId = e.target.content.deptId;
          this.monitorLnglat = e.target.content.lnglat;
          this.getVehicleInfowindow(this.vin, this.deptId);
        });
        AMap.event.addListener(this.varMarker, "mouseover", (e) => {
          e.target.setTop(true);
        });
        AMap.event.addListener(this.varMarker, "mouseout", (e) => {
          e.target.setTop(false);
        });
      }
      this.$nextTick(() => {
        this.map.add(this.vehicleMarker);
        // if (this.locationError) {
        this.map.setFitView();
        // }
      });
    },

    // 点击查询车辆详情
    async getVehicleInfowindow(vin, deptId) {
      if (this.routeLine) {
        this.driving.clear();
        this.map.remove(this.routeLine);
        this.routeLine = null;
      }
      let { data: res } = await this.$axios.get(
        "/api/v3/maintain/monitor/vehicle/details?deptId=" +
          deptId +
          "&vin=" +
          vin
      );
      if (res.code == 1) {
        this.vehicleInfoWindowData = {};
        this.vehicleInfoWindowData = res.data;
        this.stationVehicleId = this.vehicleInfoWindowData.stationId;
        this.vehicleId = true;
        this.vehicleInfoWindow.show();
        this.vehicleInfoWindow.setPosition(res.data.lnglat);
        this.drivingRoutelVin = null;
        this.bankRoute = false;
        if (res.data.destLnglat && res.data.destLnglat.length > 0) {
          // 如果车辆有目的地
          this.drivingRoutelVin = this.vehicleInfoWindowData.vin;
          this.drawRouteLine(res.data.lnglat, res.data.destLnglat, "#00E46B");
        }
        sessionStorage.setItem("lnglat", res.data.lnglat);
        this.vehicleInfoSwitch = !this.vehicleInfoSwitch;
      } else {
        this.$message.warning(res.msg);
      }
    },

    // 根据起始点画路线
    drawRouteLine(start, end, color) {
      console.log(start, end, color);
      if (this.routeLine || !this.drawOK) {
        this.driving.clear();
        this.map.remove(this.routeLine);
        this.routeLine = null;
        this.drivingRoutelVin = null;
        this.drawOK = true;
      }
      this.drivingRoutel = "";
      this.drivingTime = "";
      if (start.length > 0 && this.drawOK) {
        this.drawOK = false;
        // 根据起终点经纬度规划驾车导航路线
        this.driving.search(
          new AMap.LngLat(start[0], start[1]),
          new AMap.LngLat(end[0], end[1]),
          (status, result) => {
            var path = [];
            for (var i = 0, l = result.routes[0].steps.length; i < l; i++) {
              var step = result.routes[0].steps[i];
              for (var j = 0, n = step.path.length; j < n; j++) {
                path.push(step.path[j]);
              }
            }
            this.drivingRoutel = result.routes[0].distance / 1000 + "公里";
            let hours = Math.floor(result.routes[0].time / 3600);
            let mintinus = Math.floor(result.routes[0].time / 60 - hours * 60);
            this.drivingTime = hours + "小时" + mintinus + "分钟";
            this.bankRoute = true;
            this.routeLine = new AMap.Polyline({
              map: this.map,
              path: path,
              isOutline: false,
              strokeWeight: 4,
              strokeColor: color,
              lineJoin: "round",
            });
            this.drawOK = true;
          }
        );
      }
    },

    // 点击跳转车辆详情
    getVehicleDetail(vin) {
      if (!vin) {
        this.$message.warning("车架号为空，无法查看车辆详情");
      } else {
        this.$router.push({
          name: "VehicleInfo",
          params: {
            vin: vin,
            active: "real",
          },
        });
        this.$store.state.MenuStore.menu_path = "车辆管理 > 车辆管理";
      }
    },

    // 添加点标记
    addPointsMarkers(points) {
      var style = [
        {
          url: require("@/assets/images/geological/massGreen.png"),
          anchor: new AMap.Pixel(6, 6),
          size: new AMap.Size(14, 14),
          zIndex: 110,
        },
        {
          url: require("@/assets/images/geological/massGreyGreen.png"),
          anchor: new AMap.Pixel(6, 6),
          size: new AMap.Size(14, 14),
          zIndex: 110,
        },
        {
          url: require("@/assets/images/geological/massYellow.png"),
          anchor: new AMap.Pixel(6, 6),
          size: new AMap.Size(14, 14),
          zIndex: 110,
        },
        {
          url: require("@/assets/images/geological/massOrange.png"),
          anchor: new AMap.Pixel(6, 6),
          size: new AMap.Size(14, 14),
          zIndex: 110,
        },
        {
          url: require("@/assets/images/geological/mass.png"),
          anchor: new AMap.Pixel(6, 6),
          size: new AMap.Size(14, 14),
          zIndex: 110,
        },
        {
          url: require("@/assets/images/geological/massRed.png"),
          anchor: new AMap.Pixel(6, 6),
          size: new AMap.Size(14, 14),
          zIndex: 110,
        },
      ];

      this.pointsMassMarks = new AMap.MassMarks(points, {
        zIndex: 5, // 海量点图层叠加的顺序
        zooms: [3, 20], // 在指定地图缩放级别范围内展示海量点图层
        style: style, // 设置样式对象
        offset: new AMap.Pixel(128, 128), //相对于基点的偏移位置
        bubble: false,
      });

      //添加聚合组件
      AMap.plugin(["AMap.MarkerCluster"], () => {
        this.cluster = new AMap.MarkerCluster({
          points: points, // 海量点数据，数据中需包含经纬度信息字段 lnglat
          styles: style,
        });
        this.map.addControl(this.cluster);
      });

      // console.log(this.cluster);

      points.forEach((item) => {
        if (item.monitorArea <= 1) {
          item.style = 0;
        } else if (item.monitorArea <= 5 && item.monitorArea > 1) {
          item.style = 1;
        } else if (item.monitorArea <= 10 && item.monitorArea > 5) {
          item.style = 2;
        } else if (item.monitorArea <= 30 && item.monitorArea > 10) {
          item.style = 3;
        } else if (item.monitorArea <= 50 && item.monitorArea > 30) {
          item.style = 4;
        } else {
          item.style = 5;
        }
      });
      this.pointsMassMarks = new AMap.MassMarks(points, {
        zIndex: 10, // 海量点图层叠加的顺序
        zooms: [3, 20], // 在指定地图缩放级别范围内展示海量点图层
        style: style, // 设置样式对象
        offset: new AMap.Pixel(128, 128), //相对于基点的偏移位置
        bubble: false,
      });
      this.marker = new AMap.Marker({
        // content: `<div style='color:#fff;font-size:12px;white-space:nowrap'>面积：${this.area}亩</div>`,
        offset: new AMap.Pixel(-40, -20), //设置偏移量
      });

      // 点击标记点显示占地区域面积
      AMap.event.addListener(this.pointsMassMarks, "click", (e) => {
        console.log(e.data.lnglat);
        this.marker.show();
        this.showCircle = true;
        let lnglat = e.data.lnglat;
        this.area = e.data.monitorArea;
        // this.drawCircle(this.area, lnglat);
        this.map.add(this.marker);
        this.marker.setPosition(lnglat);
        this.marker.setContent(
          `<div style='color:#fff;font-size:10px;white-space:nowrap'>${this.area}亩</div>`
        );
      });

      this.$nextTick(() => {
        // 将海量点添加至地图实例
        this.pointsMassMarks.setMap(this.map);
        if (this.vehicleMarker.length > 0) {
          this.map.setFitView();
        }
      });
    },

    initMap() {
      this.map = new AMap.Map("map-box", {
        resizeEnable: true,
        zoom: 8,
        zooms: [3, 20],
        expandZoomRange: true,
        // center: [120.08, 28.62],
        mapStyle: "amap://styles/grey",
      });
      // AMap.plugin("AMap.Geolocation", () => {
      //   let geolocation = new AMap.Geolocation({
      //     enableHighAccuracy: true, //是否使用高精度定位，默认:true
      //     showButton: false,
      //     showMarker: false,
      //   });
      //   this.map.addControl(geolocation);
      // 判断地图中心点
      // if (this.map.getCenter()) {
      //   console.log('center');
      //   this.map.setCenter(this.map.getCenter());
      // } else {
      // geolocation.getCurrentPosition();
      // AMap.event.addListener(geolocation, "error", () => {
      //   this.locationError = true;
      // });
      // });

      // scale 比例尺
      AMap.plugin(["AMap.Scale"], () => {
        this.scale = new AMap.Scale({
          visible: true,
        });
        this.map.addControl(this.scale);
      });

      // 点击地图，清除标记点信息和面积区域
      AMap.event.addListener(this.map, "click", (e) => {
        // 点击的不是标记点时
        if (this.marker && this.pointCircle && !e.data) {
          this.marker.hide();
          this.pointCircle.hide();
        }
      });

      // 车辆信息窗体
      this.vehicleInfoWindow = new AMap.Marker({
        map: this.map,
        content: this.$refs.vehicleInfowindow.$el,
        zIndex: 300,
        offset: new AMap.Pixel(30, -40),
      });
      // 初始化地图路线查询插件
      AMap.plugin("AMap.Driving", () => {
        this.driving = new AMap.Driving({
          policy: AMap.DrivingPolicy.LEAST_FEE,
          hideMarkers: true,
          isOutline: false,
          autoFitView: true,
        });
      });
      // 点击地图，清除路线规划和车辆信息窗体
      AMap.event.addListener(this.map, "click", () => {
        if (this.routeLine) {
          this.driving.clear();
          this.map.remove(this.routeLine);
          this.routeLine = null;
          this.drivingRoutelVin = null;
        }
        this.vehicleInfoWindow.hide();
      });
    },

    initWebSocket() {
      // 初始化websocket
      // ws地址
      const sessionId = window.sessionStorage.getItem("sessionId");
      // const wsuri = process.env.WS_API + `?user-number=${userNumber}`
      // const wsuri = `ws://192.168.90.152:8070/monitor;JSESSIONID=${sessionId}`; //测试环境websocket地址
      const wsuri = `ws://116.63.189.185:9070/monitor;JSESSIONID=${sessionId}`; //运营环境websocket地址
      this.websock = new WebSocket(wsuri);
      // 监听socket打开
      this.websock.onopen = function() {
        console.log("浏览器WebSocket已打开");
      };
      this.websock.onmessage = this.websocketonmessage; // 监听socket消息接收
      this.websock.onclose = this.websocketclose; // 监听socket关闭
      console.log(this.vehicleMarkerList);
    },
    //  监听socket数据接收
    websocketonmessage(e) {
      const redata = JSON.parse(e.data);
      if (!redata || redata == 1) {
        return;
      } else {
        console.log(redata);
        // 车辆jps移动
        if (redata.type == 10) {
          console.log(this.vehicleMarkerList);
          this.vehicleMarkerList.map((item) => {
            //找到对应车辆
            if (item.vin == redata.data.vin) {
              this.drivingRoutelM = null;
              this.driving.search(
                new AMap.LngLat(item.lnglat[0], item.lnglat[1]),
                new AMap.LngLat(redata.data.lnglat[0], redata.data.lnglat[1]),
                (status, result) => {
                  var path = [];
                  for (
                    var i = 0, l = result.routes[0].steps.length;
                    i < l;
                    i++
                  ) {
                    var step = result.routes[0].steps[i];
                    for (var j = 0, n = step.path.length; j < n; j++) {
                      path.push(step.path[j]);
                    }
                  }
                  this.drivingRoutelM = result.routes[0].distance;
                  if (
                    redata.data.absVehicleSpeed > 10 &&
                    this.drivingRoutelM > 50
                  ) {
                    // 车辆图标
                    item.vehicle.moveTo(
                      redata.data.lnglat,
                      redata.data.absVehicleSpeed * 50,
                      (val) => {
                        return val;
                      }
                    );
                    // 车牌号
                    item.plateNum.moveTo(
                      redata.data.lnglat,
                      redata.data.absVehicleSpeed * 50,
                      (val) => {
                        return val;
                      }
                    );
                    if (item.vin == this.vin) {
                      //当前车辆信息窗体被打开
                      this.vehicleInfoWindow.moveTo(
                        redata.data.lnglat,
                        redata.data.absVehicleSpeed * 50,
                        (val) => {
                          return val;
                        }
                      );
                    }
                    // 车辆发电
                    if (item.power) {
                      item.power.moveTo(
                        redata.data.lnglat,
                        redata.data.absVehicleSpeed * 50,
                        (val) => {
                          return val;
                        }
                      );
                    }
                  } else if (
                    redata.data.absVehicleSpeed > 10 &&
                    50 > this.drivingRoutelM
                  ) {
                    // 车辆图标
                    item.vehicle.moveTo(
                      redata.data.lnglat,
                      redata.data.absVehicleSpeed * 20,
                      (val) => {
                        return val;
                      }
                    );
                    // 车牌号
                    item.plateNum.moveTo(
                      redata.data.lnglat,
                      redata.data.absVehicleSpeed * 20,
                      (val) => {
                        return val;
                      }
                    );
                    if (item.vin == this.vin) {
                      //当前车辆信息窗体被打开
                      this.vehicleInfoWindow.moveTo(
                        redata.data.lnglat,
                        redata.data.absVehicleSpeed * 20,
                        (val) => {
                          return val;
                        }
                      );
                    }
                    // 车辆发电
                    if (item.power) {
                      item.power.moveTo(
                        redata.data.lnglat,
                        redata.data.absVehicleSpeed * 20,
                        (val) => {
                          return val;
                        }
                      );
                    }
                  } else if (
                    redata.data.absVehicleSpeed <= 100 &&
                    this.drivingRoutelM > 0
                  ) {
                    item.vehicle.setPosition(redata.data.lnglat);
                    item.plateNum.setPosition(redata.data.lnglat);
                    if (item.power) {
                      item.power.setPosition(redata.data.lnglat);
                    }
                    if (item.oil) {
                      item.oil.setPosition(redata.data.lnglat);
                    }
                    if (item.vin == this.vin) {
                      this.vehicleInfoWindow.setPosition(redata.data.lnglat);
                    }
                  }
                  item.lnglat = redata.data.lnglat;
                }
              );
              // ------------是否能解决mac系统地图闪烁问题end-------
              if (item.vin == this.drivingRoutelVin) {
                //当前车辆路线被查看
                if (this.routeLine) {
                  this.driving.clear();
                  this.map.remove(this.routeLine);
                  this.routeLine = null;
                }
                if (
                  redata.data.destLnglat &&
                  redata.data.destLnglat.length > 0
                ) {
                  //车辆自己有目的地
                  this.drawRouteLine(
                    redata.data.lnglat,
                    redata.data.destLnglat,
                    "#00E46B"
                  );
                }
              }
            }
          });
        }
        // 车辆详情
        if (redata.type == 12) {
          if (this.vin == redata.data.vin) {
            // 当前打开的信息窗体
            this.vehicleInfoWindowData = redata.data;
            this.stationVehicleId = this.vehicleInfoWindowData.stationId;
          }
        }
        // 车辆在线离线状态
        if (redata.type == 15) {
          this.vehicleMarkerList.map((item) => {
            if (redata.data.vin == item.vin) {
              if (redata.data.status == 1) {
                let icon =
                  redata.data.version == 2
                    ? require("@/assets/images/monitor/car-online-2.png")
                    : require("@/assets/images/monitor/car-online.png");
                //在线
                item.vehicle.setIcon(icon);
                item.vehicle.setzIndex(120);
              } else {
                let icon =
                  redata.data.version == 2
                    ? require("@/assets/images/monitor/car-offline-2.png")
                    : require("@/assets/images/monitor/car-offline.png");
                //离线
                item.vehicle.setIcon(icon);
                item.vehicle.setzIndex(100);
              }
            }
          });
        }
        // 车辆发电状态
        // if (redata.type == 16) {
        //   this.vehicleMarkerList.map((item) => {
        //     if (redata.data.vin == item.vin) {
        //       if (redata.data.status == 1) {
        //         //发电
        //         var powerContent =
        //           "<img style='width:14px;height:18px'  src='" +
        //           require("@/assets/images/monitor/icon-powering.png") +
        //           "'/>";
        //         this.powerStateMarker = new AMap.Marker({
        //           zIndex: 200,
        //           content: powerContent,
        //           position: item.lnglat,
        //           offset: new AMap.Pixel(-30, -12),
        //           map: this.map,
        //         });
        //         this.map.add(this.powerStateMarker);
        //         item.power = this.powerStateMarker;
        //       } else {
        //         //停止发电
        //         if (item.power) {
        //           this.map.remove(item.power);
        //           item.power = "";
        //         }
        //       }
        //     }
        //   });
        // }
      }
    },
    //  监听socket关闭
    websocketclose() {
      // console.log(e);
      // this.websock.close()
      // this.$notify({
      //   title: '错误',
      //   message: 'websocket已关闭，无法接收实时报警信息,请联系汪汪',
      //   type: 'error',
      //   duration: 5000
      // })
    },
  },
};
</script>

<style lang="scss" scoped>
$font-name: "Arial Negreta", "Arial";
.photographManage-container {
  position: relative;
  min-width: 1650px;
  background-color: #fff;
  height: 100%;
  #map-box {
    width: 100%;
    height: 100%;
  }
  .watch-header {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    margin: auto;
    width: 100%;
    max-width: 1660px;
    height: 75px;
    background: url("../../../assets/images/monitor/watch-header.png") no-repeat;
    background-size: 100% auto;
    z-index: 999;
    .header-title {
      width: 100%;
      text-align: center;
      font-size: 40px;
      font-family: $font-name;
      font-weight: bold;
      color: #00c9f0;
      letter-spacing: 4px;
    }
  }
  .close-switch {
    position: absolute;
    right: 20px;
    top: 105px;
    width: 106px;
    text-align: center;
    background: #031d44;
    border-radius: 3px;
    padding: 10px 15px;
    box-sizing: border-box;
    .switchItem {
      line-height: 30px;
      position: relative;
      text-align: left;
      .imgWrapper {
        display: inline-block;
        width: 40px;
        height: 24px;
        text-align: center;
      }
      .switchBtn {
        position: absolute;
        top: 3px;
        margin-left: 5px;
        /deep/ .el-switch__core {
          width: 30px !important;
          height: 10px;
        }
        /deep/ .el-switch__core:after {
          top: -4px;
          left: 15px;
          width: 16px;
          height: 16px;
        }
      }
    }

    img {
      width: auto;
      height: 24px;
    }
  }

  .infoWindow {
    position: relative;
    padding: 10px;
    background: rgba(255, 255, 255, 0.8);
    font-size: 12px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #000000;
    line-height: 20px;
    width: 185px;
    border-radius: 4px;
    box-sizing: border-box;
    .orderTime {
      position: absolute;
      width: 185px;
      line-height: 20px;
      background: rgba(255, 255, 255, 0.8);
      top: -22px;
      left: 0;
      border-radius: 3px;
      padding-left: 10px;
    }
    .infoWindow-detail {
      .carNumber {
        color: #0060ff;
      }
      .vehicleStatus {
        span {
          display: inline-block;
          text-align: center;
          width: 54px;
          height: 20px;
          border-radius: 10px;
          margin-right: 5px;
          color: rgba(255, 255, 255, 0.8);
        }
        .powering {
          background: #00beda;
        }
        .fueling {
          background: #ffa200;
        }
        .routing {
          background: #00cb4c;
        }
        .no-receive {
          background: #888888;
        }
        .no-order {
          background: #0078ff;
        }
      }
    }
    // 三角形
    .delta {
      position: absolute;
      left: -10px;
      top: 30px;
      width: 0;
      height: 0;
      border-top: 8px solid transparent;
      border-right: 10px solid rgba(255, 255, 255, 0.8);
      border-bottom: 8px solid transparent;
    }
    // 查看详情
    .checkDetail {
      position: absolute;
      right: -30px;
      top: 0;
      width: 20px;
      height: 82px;
      background: rgba(0, 148, 255, 0.8);
      border-radius: 0px 3px 3px 0px;
      color: #fff;
      text-align: center;
      padding: 5px;
      cursor: pointer;
    }
  }

  ::v-deep .amap-scalecontrol {
    left: 10px !important;
    .amap-scale-text {
      color: #fff;
    }
  }
}
</style>